/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adjustDisputedAmount} from '../api'

export const useMutationAdjustDisputedAmount = createReactQueryMutationHook('adjustDisputedAmount', adjustDisputedAmount)
